<template>
   <Quiz46Status v-if="isQuiz46" :status="quiz46Status" />
   <div v-else>
     <lottie v-if="defaultOptions" :options="defaultOptions" :height="300" :width="300" v-on:animCreated="handleAnimation"/>
   </div>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
//const axios = require("axios").default;
//import router from "./../router";
import _ from 'lodash';
//import Tabs from 'vue-tabs-with-active-line';
import Lottie from './lottie.vue';
import Quiz46Status from '@/components/Quiz46Status.vue';
import { loadAnimation } from '@/services/lottieLoader';
import liffService from "@/services/liff";

// @ is an alias to /src
export default {
  name: "Loading",
  async created() {
    this.readQuizParams();
    if (this.isQuiz46 && this.previewMode) {
      const allowedStates = ["loading", "correct", "incorrect", "already", "error"];
      this.quiz46Status = allowedStates.includes(this.previewState)
        ? this.previewState
        : "correct";
      return;
    }
    // LIFF is already initialized by router guard
    await this.loadUserData();
    if (!this.isQuiz46) {
      const animate = await loadAnimation('dicks');
      this.defaultOptions = {animationData: animate};
    }
  },
  components: {
      'lottie': Lottie,
      Quiz46Status
  },
  data() {
    return {
      displayName: "",
      //email: "",
      userId: "",//Uf67a993bc2d1d206693634a1ba806798
      pictureUrl: "",
      statusMessage: "",
      firstname: "",
      master: "5",
      agent: "-MBjPYX3fRJGs3gklUHq",
      lastname: "",
      bank: "",
      accountNo: "",
      tel: "",
      mastername: "",
      isDisabled: true,
      loading: true,
      error: "",
      mycoin:0,
      rewards:[],
      userKey:'',
      quizId:0,
      answer:0,
      previewMode:false,
      previewState:"correct",
      quiz46Status:"loading",
      defaultOptions: null,
      animationSpeed: 1
    };
  },
  computed: {
    isQuiz46() {
      return Number(this.quizId) === 46;
    }
  },
  methods: {
    readQuizParams() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      const params = new URLSearchParams(decodeURIComponent(window.location.search));
      const isLocalhost = ["localhost", "127.0.0.1"].includes(
        window.location.hostname
      );
      this.quizId = query.quizId || params.get("quizId") || 0;
      this.answer = query.answer || params.get("answer") || 0;
      this.previewMode =
        isLocalhost &&
        String(query.preview || params.get("preview") || "") === "1";
      this.previewState = String(query.state || params.get("state") || "correct");
    },
    async finishQuiz46(status, message) {
      this.quiz46Status = status;
      try {
        await window.liff.sendMessages([{ type: "text", text: message }]);
        await new Promise(resolve => window.setTimeout(resolve, 1400));
        window.liff.closeWindow();
      } catch (error) {
        this.quiz46Status = "error";
        console.error("Unable to send Quiz 46 result:", error);
      }
    },
    handleAnimation: function (anim) {
        this.anim = anim;
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) {
        if (this.isQuiz46) this.quiz46Status = "error";
        return;
      }

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";

      this.displayName = profile.displayName ? profile.displayName : "none";
      this.statusMessage = profile.statusMessage
        ? profile.statusMessage
        : "none";
      if (this.userId) {
        const user = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userId).once("value")).val();
        if (user) {
            await firebase.firestore().collection('quiz').where('userId','==',this.userId).where('quizId','==',this.quizId).get().then(async (snapshot) => {
                if(snapshot.size > 0) {
                    if(this.quizId == 46) {
                        await this.finishQuiz46(
                          "already",
                          "ข้อนี้ตอบไปแล้วนะคะ หนึ่งบัญชีตอบได้หนึ่งครั้ง รอร่วมสนุกกับคำถามใหม่ได้เลยค่ะ"
                        );
                        return;
                    }
                    await window.liff.sendMessages([
                        {
                            "type": "text",
                            "text": "ลูกค้าตอบคำถามแล้วนะคะ รอร่วมกิจกรรมกับน้องออโต้ใหม่นะคะ จะมาเร็วๆนี้ค่ะ 😘😘",
                        }
                    ]);
                    window.liff.closeWindow();
                }else{
                    firebase.firestore().collection('quiz').doc(this.userId+'-'+this.quizId).set({
                        userId:this.userId,
                        quizId:this.quizId,
                        answer:this.answer,
                        createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
                    }).then(async()=>{
                        if(this.quizId == 1 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ และร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT น้องออโต้เสียใจด้วยนะคะทางเราตอนนี้มีแค่แลกเป็นเครดิตเท่านั้นค่ะ สนใจสอบถามแอดมินได้ 24 ชั่วโมงนะคะ และร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 2 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ และร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 2){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT น้องออโต้เสียใจลืมน้องออโต้คนนี้ซะแล้ว ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 3 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ และร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 3){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT โบนัส 5% เรามีทุกวัน 2 ทุ่มถึง 3 ทุ่มนะคะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 4 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ และร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 4){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT โบนัส 10% เรามีทุกวันเสาร์-อาทิตย์ เที่ยงถึงเที่ยงครึ่งนะคะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 5 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ และร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 5){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT 300 coins แลกได้ 500 เครดิตนะคะ สะสมไว้เยอะๆนะคะและไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 6 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ พรุ่งนี้เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 6){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT Golden Spin มี 30 coins ถึง 300 coins เลยนะคะ พรุ่งนี้เตรียมพร้อมพบกับโปรสุดว้าววได้เลยค่ะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 7 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ และร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 7){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT โลโก้ของเราคือ เพกาซัสนะคะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 8 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ ถ้าทำตามขั้นตอนนี้ไม่ต้องส่งสลิปก็ได้นะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 8){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT เว็บของเราโอนเงินเข้ามาก่อนแล้วค่อยแจ้งฝากนะคะและไม่ต้องส่งสลิปก็ได้ค่ะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 9 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ เปิดเสียงด้วยนะคะจะได้ยินเสียง Werewolf ด้วยค่ะ 🐺🎶",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 9){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT จะเจอได้ที่หน้าหมุนวงล้อนะคะ อย่าลืมเปิดเสียงด้วยนะคะจะได้ยินเสียง Werewolf ด้วยค่ะ 🐺🎶",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 19 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ รบกวนโอนเข้าบัญชีใหม่ด้วยนะคะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 19){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แง้ๆ ทางเราเปลี่ยนบัญชีใหม่แล้วรบกวนพี่ดูบัญชีใหม่จากหน้าแจ้งฝากได้เลยเพื่อให้น้องออโต้ทำงานได้รวดเร็วนะคะ ขอบคุณค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 11 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 11){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แง้ๆ ต้องเป็นสีเทานะคะพี่ขา ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 12 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 12){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แง้ๆ ขอแค่พูดจาเพราะพริ้งก็รับไปเลยนะคะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 13 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 13){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "งือๆ ได้รับเหรียญ x5 นะคะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 14 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ เปิดเสียงด้วยนะคะจะได้ยินเสียง ซานตาคอส ด้วยค่ะโฮ๊ะๆ 🎅🏻 🎶  🎁",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 14){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT จะเจอได้ที่หน้าเล่นรูเล็ตนะคะ เปิดเสียงด้วยนะคะจะได้ยินเสียง ซานตาคอส ด้วยค่ะโฮ๊ะๆ 🎅🏻 🎶  🎁",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 15 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 15){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "TT ทุกวันที่หวยออก ตอน 16.00-17.00 นะคะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 16 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ทันทีเลยค่ะ ไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 16){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "😭 😭 0 - 300 เลยนะคะ มาๆลุ้นกันค่ะไว้ร่วมสนุกกับทางเราได้ใหม่เตรียมตัวไว้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 17 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins โปรเริ่มวันนี้เป็นต้นไปแล้วนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 17){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "😭 😭 เติมเงินครั้งแรกทุกวัน จ-ศ นะคะ รับเพิ่ม 5% และ เหรียญ x2 เลยค่ะ โปรเริ่มวันนี้เป็นต้นไปแล้วนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 18 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ฝากแชร์ให้เพื่อนๆ มาสนุกด้วยกันนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 18){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "😭 😭 15% เลยนะคะ ฝากแชร์ให้เพื่อนๆ มาสนุกด้วยกันนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 20 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 20){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่ววว! 0-100 เลยนะคะ แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 21 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 21){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่ววว! สีส้มนะคะ แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 22 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 22){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "เง้อเศร้า TT สีฟ้านะคะ แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 23 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins และฝากชวนเพื่อนมาสนุกด้วยกันด้วยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 23){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่วๆ @ufaeasy888v1 ฝากชวนเพื่อนมาสนุกด้วยกันด้วยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 24 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins และมาสนุกด้วยกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 24){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "งือๆ พรุ่งนี้เจอโปร 10% ตอนเที่ยงนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 25 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins และเจอกับโอนก่อนชนะวันพรุ่งนี้นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 25){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "งือๆ 20 คนนะคะ และเจอกับโอนก่อนชนะวันพรุ่งนี้นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 26 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 26){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่ววว! สีเขียวนะคะ แล้วมาร่วมสนุกกันใหม่นะคะ 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 27 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 27){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "งือๆ 100 เหรียญนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 28 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 28){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่ว ฝาก 10 ถอน 50 นะคะ แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 29 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 29){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "เศร้า.. ปุ่มแนะนำเพื่อนนะคะ แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 30 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins พรุ่งนี้มาเจอกันนะคะกับโปรเข้าวิน 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 30){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "สะอื้นๆ ทุกๆ 150 ลุ้นหวยได้ฟรี 1 หมายเลขนะคะ พรุ่งนี้มาเจอกันนะคะกับโปรเข้าวิน 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 31 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แนะนำเพื่อนให้เร็วเลยค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 31){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แง่วๆ ได้จากยอดฝากทั้งวันและทุกวันเลยค่ะ แนะนำเพื่อนให้เร็วเลยค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 32 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 32){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่วๆๆ UFSKQ88V401 นะคะ ยินดีด้วยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 33 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins 😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 33){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่วๆๆ 10% นะคะ แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 34 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins ฝากแนะนำเพื่อนมาร่วมสนุกกันเยอะๆนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 34){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่วๆๆ 13 โมงทุกวันนะคะ ฝากแนะนำเพื่อนมาร่วมสนุกกันเยอะๆนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 35 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins เราสามารถแชร์ต่อได้เรื่อยๆแล้วนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 35){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่วๆๆ ปุ่มแชร์ให้เพื่อนนะคะ เราสามารถแชร์ต่อได้เรื่อยๆแล้วนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 36 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่ค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 36){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่วๆๆ ค่าย PG นะคะ แล้วมาร่วมสนุกกันใหม่ค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 37 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่ค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 37){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่วๆๆ 7 ปุ่มเลยนะคะ แล้วมาร่วมสนุกกันใหม่ค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 38 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่ค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 38){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่วๆๆ 50 รับ 100 เลยนะคะ แล้วมาร่วมสนุกกันใหม่ค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 39 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่ค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 39){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่วๆๆ 250 นะคะ แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 40 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่ค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 40){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "แป่วๆๆ 3 หีบนะคะ แล้วมาร่วมสนุกกันใหม่นะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 41 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins แล้วมาร่วมสนุกกันใหม่ค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 41){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "เศร้า.. ค่าย PG นะคะ แล้วมาร่วมสนุกกันใหม่ค่ะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 42 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins\n👉 คืนยอดเล่นทุกวัน 09:00 น.\n👉 แจ้งแอดมินข้าวหอมได้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 42){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "😭 แงๆ.. ยอดเล่นนะคะ\n👉 เสียรับ 5%\n👉 ได้รับ 1%\n👉 คืนยอดเล่นทุกวัน 09:00 น.\n👉 แจ้งแอดมินข้าวหอมได้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 43 && this.answer==3){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins\n👉 คืนยอดเล่นทุกวัน 09:00 น.\n👉 แจ้งแอดมินข้าวหอมได้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 43){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "😭 แหง่วๆ.. \n👉 คืนยอดเล่นทุกวัน 09:00 น.\n👉 แจ้งแอดมินข้าวหอมได้เลยนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 44 && this.answer==2){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 🎉 ปังปุริเย่!! น้องออโต้ยินดีด้วยนะคะ รับเพิ่ม +5 coins😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 44){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "😭 แหง่วๆ.. \n👉 เกมส์เป่ายิ้งฉุบนะคะ😘😘",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 45 && this.answer==1){
                            await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "🎉 ถูกต้องค่ะ! รับเพิ่ม +5 coins ทันที\n🔒 ก่อนโอนทุกครั้ง เปิดหน้าฝากเงินและคัดลอกเลขบัญชีที่แสดงล่าสุดนะคะ",
                            }
                            ]);
                            window.liff.closeWindow();
                        }else if(this.quizId == 45){
                          await window.liff.sendMessages([
                            {
                                "type": "text",
                                "text": "เกือบถูกแล้วค่ะ 😊\n🔒 วิธีที่ปลอดภัยคือเปิดหน้าฝากเงิน แล้วคัดลอกเลขบัญชีที่แสดงล่าสุดทุกครั้งก่อนโอนนะคะ",
                            }
                          ]);
                          window.liff.closeWindow();
                        }else if(this.quizId == 46 && this.answer==2){
                            await this.finishQuiz46(
                              "correct",
                              "ตอบถูกค่ะ! โบนัสแนะนำ = (1,000 - 300) × 5% = 35 บาท รับเพิ่ม +5 coins ทันทีค่ะ"
                            );
                        }else if(this.quizId == 46){
                            await this.finishQuiz46(
                              "incorrect",
                              "เกือบถูกแล้วค่ะ คำตอบคือ 35 บาท เพราะโบนัสแนะนำ = (1,000 - 300) × 5% ค่ะ"
                            );
                        }
                    });
                }
            });
        }else{
          window.liff.closeWindow();
        }
      }
      this.isDisabled = false;
    },
  }
};
</script>
<style scoped>
#cover-spin {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#cover-spin::after {
  content: "";
  display: block;
  position: absolute;
  left: 48%;
  top: 40%;
  width: 40px;
  height: 40px;
  border-style: solid;
  border-color: black;
  border-top-color: transparent;
  border-width: 4px;
  border-radius: 50%;
  -webkit-animation: spin 0.8s linear infinite;
  animation: spin 0.8s linear infinite;
}
.canredeem {
  border-radius: 7px; 
  margin-top: 10px; 
  height: 32px; 
  background: #EE4D2D; 
  align-items: center; 
  justify-content: center; 
  display: flex;
}
.cantredeem {
  border-radius: 7px; 
  margin-top: 10px; 
  height: 32px; 
  background: #a5a4a4; 
  align-items: center; 
  justify-content: center; 
  display: flex;
}
button.tabs__item .tabs__item_active .default-tabs__item_active .default-tabs__item {
  justify-content: center !important;
  flex: 1 !important;
  display: flex !important;
}
</style>
<style lang="scss">
.default-tabs {
  position: relative;
  margin: 0 auto;
  display: flex;
  &__item {
    justify-content: center;
    flex: 1;
    display: flex;
    //display: inline-block;
    margin: 0 5px;
    padding: 10px;
    padding-bottom: 8px;
    padding-top: 0px;
    font-size: 16px;
    letter-spacing: 0.8px;
    color: #fff;
    text-decoration: none;
    border: none;
    background-color: transparent;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: all 0.25s;
    &_active {
      color: #E95454;
    }
    &:hover {
      border-bottom: 2px solid #E95454;
      color: #E95454;
    }
    &:focus {
      outline: none;
      border-bottom: 2px solid #E95454;
      color: #E95454;
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }
  &__active-line {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background-color: #E95454;
    transition: transform 0.4s ease, width 0.4s ease;
  }
}
</style>
